export const DEFAULT_AVATAR_URL = '/default-avatar.png'

export const getSafeAvatarUrl = avatarUrl => {
  console.log(
    '%c[Avatar] URL recebida:',
    'color: #0ea5e9; font-weight: bold;',
    avatarUrl
  )
  if (!avatarUrl || typeof avatarUrl !== 'string') {
    console.log(
      '%c[Avatar] ⚠️ URL inválida, nula ou não é string. Usando avatar padrão.',
      'color: #f59e0b;'
    )
    return DEFAULT_AVATAR_URL
  }

  const trimmedUrl = avatarUrl.trim()
  if (!trimmedUrl) {
    console.log(
      '%c[Avatar] ⚠️ URL vazia após trim. Usando avatar padrão.',
      'color: #f59e0b;'
    )
    return DEFAULT_AVATAR_URL
  }

  if (trimmedUrl.startsWith('/')) {
    console.log(
      '%c[Avatar] ✅ URL relativa aceita:',
      'color: #22c55e;',
      trimmedUrl
    )
    return trimmedUrl
  }

  try {
    const parsedUrl = new URL(trimmedUrl)
    console.log(
      '%c[Avatar] ✅ URL externa aceita:',
      'color: #22c55e;',
      parsedUrl.href
    )
    return parsedUrl.href
  } catch (_error) {
    console.log('%c[Avatar] ❌ Erro ao parsear URL:', 'color: #ef4444;', _error)
    return DEFAULT_AVATAR_URL
  }
}

export const applyAvatarFallback = event => {
  const target = event?.target
  if (!target || target.dataset.avatarFallbackApplied === '1') {
    return
  }

  console.warn(
    '%c[Avatar] 🔄 Falha no carregamento da imagem (onError). Redirecionando para fallback:',
    'color: #ef4444; font-weight: bold;',
    { originalSrc: target.src, fallback: DEFAULT_AVATAR_URL }
  )

  target.dataset.avatarFallbackApplied = '1'
  target.src = DEFAULT_AVATAR_URL
}

export const getAvatarImgProps = () => ({
  referrerPolicy: 'no-referrer',
  onError: applyAvatarFallback
})
